import React, { createContext, useState, useEffect, useContext } from 'react';
import { googleMapsService } from '../services/googleMaps.service';
import { useAuth } from '../hooks/useAuth';

export const GoogleMapsContext = createContext(null);

export const GoogleMapsProvider = ({ children }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        if (isAuthenticated && !isLoaded && !loading) {
            initializeGoogleMaps();
        }
    }, [isAuthenticated, isLoaded, loading]);

    const initializeGoogleMaps = async () => {
        setLoading(true);
        setError(null);
        
        try {
            await googleMapsService.initializeGoogleMaps();
            setIsLoaded(true);
        } catch (err) {
            setError(err.message);
            console.error('Google Maps initialization failed:', err);
        } finally {
            setLoading(false);
        }
    };

    const value = {
        isLoaded,
        loading,
        error,
        initializeGoogleMaps
    };

    return (
        <GoogleMapsContext.Provider value={value}>
            {children}
        </GoogleMapsContext.Provider>
    );
};

export const useGoogleMaps = () => {
    const context = useContext(GoogleMapsContext);
    if (!context) {
        throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
    }
    return context;
}; 